import { type CSSProperties } from 'react';

import { SearchResultCardRequestAccessLabel } from './SearchResultCardRequestAccessLabel';
import { SearchResultCardPreferences } from './SearchResultCardPreferences';
import { SearchResultCardLocation } from './SearchResultCardLocation';
import { SearchResultCardLink } from './SearchResultCardLink';
import { SearchResultCardHeadline } from './SearchResultCardHeadline';
import { SearchResultCardContent } from './SearchResultCardContent';
import { SearchResultCardArticleWrapper } from './SearchResultCardArticleWrapper';
import { SearchResultCardApproximateLocation } from './SearchResultCardApproximateLocation';
import { RestrictedSearchResultCardImage } from './RestrictedSearchResultCardImage';

export const RestrictedSearchResultCard = ({ style }: { style?: CSSProperties }) => (
  <SearchResultCardArticleWrapper style={style}>
    <RestrictedSearchResultCardImage />
    <SearchResultCardContent>
      <SearchResultCardPreferences />
      <SearchResultCardLocation />
      <SearchResultCardHeadline />
      <SearchResultCardRequestAccessLabel />
      <SearchResultCardLink />
    </SearchResultCardContent>
    <SearchResultCardApproximateLocation />
  </SearchResultCardArticleWrapper>
);

RestrictedSearchResultCard.displayName = 'RestrictedSearchResultCard';
